const GIPHY_TYPE = "wix-draft-plugin-giphy";
export {
  GIPHY_TYPE
};
//# sourceMappingURL=types.js.map
